module.exports = __webpack_public_path__ + "static/media/layout-2.5afd4b42.jpg";